const languageList = ['de', 'en', 'es', 'fr', 'it', 'ja', 'zh-Hant'];

export default languageList;
